import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonPopover, IonSelect, IonSelectOption, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { closeOutline, ellipsisVertical, folderOutline, logOutOutline, settingsOutline } from 'ionicons/icons';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { imprimirCupom, imprimirCupomCozinha } from '../../../../../Utils/EscPosGenerator';
import { abrirTotem, alterarTotem, empresaCarregar, fecharTotem, listaEquipePorPerfil, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import InactivityOverlay from './Components/InactivityOverlay';
import ProgressBar from './Components/ProgressBar';
import TelaCardapio from './Components/TelaCardapio';
import TelaConfirmacao from './Components/TelaConfirmacao';
import TelaIdentificacao from './Components/TelaIdentificacao';
import TelaInicial from './Components/TelaInicial';
import TelaPagamento from './Components/TelaPagamento';
import TelaRetirada from './Components/TelaRetirada';
import TelaRevisao from './Components/TelaRevisao';
import './Totem.css';
import { TotemProvider, useTotem } from './TotemContext';
import { TOTEM_STEPS, TotemStep } from './TotemFlow';

const INACTIVITY_TIMEOUT = 20000; // 20 segundos

const TotemInner: React.FC = () => {
    const history = useHistory();
    const { loja, dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const { nomeMenu, setNomeMenu } = useContext(MessageContext);
    const { showPagamentoMaquininha } = useContext(MessageContext);
    const {
        step, setStep,
        pedidoPk, setPedidoPk,
        numeroPedido, setNumeroPedido,
        clienteNome, setClienteNome,
        produtos, setProdutos,
        tipoRetirada, setTipoRetirada,
        formaPagamento, setFormaPagamento,
        valorTotal, setValorTotal,
        resetTotem,
    } = useTotem();

    const [showLoading, setShowLoading] = useState(false);
    const [textToast, setTextToast] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [showInactivity, setShowInactivity] = useState(false);
    const [clienteTotemPk, setClienteTotemPk] = useState('');

    // Popover menu
    const [showPopover, setShowPopover] = useState(false);
    const [popoverEvent, setPopoverEvent] = useState<any>(null);

    // Totem selection modal
    const [listaTotens, setListaTotens] = useState<any[]>([]);
    const [showModalSelecionarTotem, setShowModalSelecionarTotem] = useState(false);
    const [totemSelecionadoTemp, setTotemSelecionadoTemp] = useState('');

    const openPopover = (e: any) => {
        e.persist();
        setPopoverEvent(e);
        setShowPopover(true);
    };

    const closePopover = () => {
        setShowPopover(false);
        setPopoverEvent(null);
    };

    // Inactivity timer - direct interval+ref approach (same pattern as TelaConfirmacao)
    const INACTIVITY_SECONDS = INACTIVITY_TIMEOUT / 1000; // 120s
    const inactivityRef = useRef(INACTIVITY_SECONDS);
    const inactivityIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
    const pagamentoModalAbertaRef = useRef(false);

    const [mostrarHeader, setMostrarHeader] = useState(false);

    const pressTimerRef = useRef<any>(null);

    const handlePressStart = () => {
        pressTimerRef.current = setTimeout(() => {
            setMostrarHeader(true);
        }, 5000); // segura 5 segundos
    };

    const handlePressEnd = () => {
        clearTimeout(pressTimerRef.current);
    };

    // Mantém ref sincronizado com estado do modal de pagamento
    useEffect(() => {
        pagamentoModalAbertaRef.current = !!showPagamentoMaquininha;
        if (showPagamentoMaquininha) {
            // Reseta contagem ao abrir o modal para não disparar ao fechar
            inactivityRef.current = INACTIVITY_SECONDS;
        }
    }, [showPagamentoMaquininha]);



    // // === DEBUG — remover em produção ===
    // const [debugSeconds, setDebugSeconds] = useState(INACTIVITY_SECONDS);
    // const [debugStatus, setDebugStatus] = useState('aguardando');
    // const debugIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

    // useEffect(() => {
    //     if (debugIntervalRef.current) clearInterval(debugIntervalRef.current);
    //     debugIntervalRef.current = setInterval(() => {
    //         setDebugSeconds(Math.max(0, Math.round(inactivityRef.current)));
    //         if (step === 'inicio' || step === 'confirmacao') {
    //             setDebugStatus('inativo (step ignorado)');
    //         } else if (showInactivity) {
    //             setDebugStatus('🔴 overlay visível');
    //         } else {
    //             setDebugStatus('✅ monitorando');
    //         }
    //     }, 500);
    //     return () => { if (debugIntervalRef.current) clearInterval(debugIntervalRef.current); };
    // }, [step, showInactivity]);
    // // === FIM DEBUG ===

    const resetInactivity = useCallback(() => {
        inactivityRef.current = INACTIVITY_SECONDS;
    }, []);

    useEffect(() => {
        // Clear any previous interval
        if (inactivityIntervalRef.current) clearInterval(inactivityIntervalRef.current);

        if (step === 'inicio' || step === 'confirmacao') {
            // No inactivity on inicio or confirmacao (confirmacao has its own timer)
            return;
        }

        inactivityRef.current = INACTIVITY_SECONDS;
        inactivityIntervalRef.current = setInterval(() => {
            // Pausa o timer enquanto o modal de pagamento estiver aberto
            if (pagamentoModalAbertaRef.current) return;
            inactivityRef.current -= 1;
            if (inactivityRef.current === 0) {
                // Não cancela o interval: ao clicar em Continuar, resetInactivity reinicia a contagem
                setShowInactivity(true);
            }
        }, 1000);

        const events = ['touchstart', 'mousedown', 'keydown', 'scroll'];
        events.forEach(ev => window.addEventListener(ev, resetInactivity, { passive: true }));

        return () => {
            if (inactivityIntervalRef.current) clearInterval(inactivityIntervalRef.current);
            events.forEach(ev => window.removeEventListener(ev, resetInactivity));
        };
    }, [step, resetInactivity]);

    const handleContinueActivity = () => {
        setShowInactivity(false);
        inactivityRef.current = INACTIVITY_SECONDS;
    };

    const handleInactivityReset = () => {
        setShowInactivity(false);
        resetTotem();
    };

    // Load empresa data and catalog on mount
    useEffect(() => {

    }, []);

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
        setNomeMenu("Totem");
        carregarEmpresa();
        carregarTotem();
    })

    function carregarEmpresa() {
        setShowLoading(true);
        requestService(
            empresaCarregar.url
                .replace("{id}", loja.replaceAll(/#/g, '%23'))
                .concat("?filtro=", Buffer.from(loja).toString('base64')),
            {
                method: empresaCarregar.method,
                headers: [["token", window.localStorage.getItem("token")]],
                credentials: 'include'
            },
            history,
            (response: any) => {
                setDadosEmpresa(response.Item);
                setShowLoading(false);
            },
            (error: any) => {
                console.log(error);
                history.replace("/login/");
            }
        );
    }

    async function carregarTotem() {
        try {
            const token = window.localStorage.getItem("token") || "";
            const montarUrl = listaEquipePorPerfil.url
                .replace("{loja}", loja.replaceAll(/#/g, "%23"))
                .concat("?status=ativo&lojas=" + Buffer.from(loja).toString('base64'));

            const resp = await fetch(montarUrl.replace("{perfil}", "totem"), {
                method: "GET",
                headers: [["token", token]],
                credentials: 'include'
            });

            const result = await resp.json();

            if (result?.Items && result.Items.length > 0) {
                setListaTotens(result.Items);

                // Verificar se já tem totem salvo no localStorage
                const totemSalvo = window.localStorage.getItem("totemSelecionado");
                if (totemSalvo) {
                    const totemExiste = result.Items.find((t: any) => t.pk === totemSalvo);
                    if (totemExiste) {
                        setClienteTotemPk(totemSalvo);
                    } else {
                        // Totem salvo não existe mais, forçar seleção
                        window.localStorage.removeItem("totemSelecionado");
                        window.localStorage.removeItem("totemSelecionadoNome");
                        setShowModalSelecionarTotem(true);
                    }
                } else {
                    // Nenhum totem selecionado, mostrar modal
                    setShowModalSelecionarTotem(true);
                }
            }
            // else {
            //     // Create a default totem user
            //     const objectRequest = {
            //         cpf: "",
            //         dataAniversario: "",
            //         email: "",
            //         empresaMarca: "",
            //         endereco: "",
            //         interno: true,
            //         lojas: JSON.parse(window.localStorage.getItem("lojas") || "[]").filter((value: any) => {
            //             return loja.includes(value.empresaLojaId);
            //         }),
            //         nome: "Totem",
            //         perfil: "totem",
            //         pk: "",
            //         statusUsuario: "ativo",
            //         telefone: "55"
            //     };

            //     requestService(
            //         cadastraEquipe.url,
            //         {
            //             method: cadastraEquipe.method,
            //             headers: [["token", localStorage.getItem("token") || ""]],
            //             credentials: 'include',
            //             body: JSON.stringify(objectRequest)
            //         },
            //         history,
            //         (response: any) => {
            //             if (response?.usuario) {
            //                 setClienteTotemPk(response.usuario.pk);
            //             }
            //         },
            //         (error: any) => {
            //             console.log("error criando cliente totem", error);
            //         }
            //     );
            // }
        } catch (e) {
            console.error("Erro ao buscar cliente totem:", e);
        }
    }

    // === API calls ===
    function abrirPedido(nome: string) {
        if (!clienteTotemPk) {
            setTextToast("Aguarde, configurando totem...");
            setShowToast(true);
            return;
        }

        setShowLoading(true);
        setClienteNome(nome || "Cliente Totem");

        const objRequest = {
            tipo: "totem",
            novoNome: nome || "Cliente Totem",
            clienteid: clienteTotemPk.replaceAll(/#/g, '%23'),
        };

        requestService(
            abrirTotem.url
                .replaceAll("{id}", clienteTotemPk.replaceAll(/#/g, '%23'))
                .concat("?lojas=" + Buffer.from(loja).toString('base64')),
            {
                method: abrirTotem.method,
                headers: [["token", window.localStorage.getItem("token")]],
                body: JSON.stringify(objRequest),
                credentials: 'include'
            },
            history,
            (response: any) => {
                if (response?.message) {
                    setPedidoPk(response.message.pk);
                    setNumeroPedido(String(response.message.nomeProjeto || ''));
                    setStep('retirada');
                }
            },
            (error: any) => {
                setTextToast(error?.message || "Erro ao abrir pedido.");
                setShowToast(true);
            }
        ).finally(() => setShowLoading(false));
    }

    function salvarProdutos(prods: any[], tipoRet: string, callback?: () => void) {
        if (!pedidoPk) return;
        setShowLoading(true);

        const objRequest = {
            produtos: prods,
            tipoRetirada: tipoRet,
            enviado: false
        };

        requestService(
            alterarTotem.url.replaceAll("{id}", pedidoPk.replaceAll(/#/g, '%23')),
            {
                method: alterarTotem.method,
                headers: [["token", window.localStorage.getItem("token")]],
                body: JSON.stringify(objRequest),
                credentials: 'include'
            },
            history,
            (response: any) => {
                if (response?.dadosPedido?.Attributes) {
                    const attrs = response.dadosPedido.Attributes;
                    setValorTotal(attrs.valorTotal || '0,00');
                    setProdutos(attrs.produtos || prods);
                }
                if (callback) callback();
            },
            (error: any) => {
                setTextToast(error?.message || "Erro ao salvar produtos.");
                setShowToast(true);
            }
        ).finally(() => setShowLoading(false));
    }

    function fecharPedido(fpOverride?: any[], callback?: () => void) {
        if (!pedidoPk) return;
        setShowLoading(true);

        const fp = fpOverride || formaPagamento;

        const objRequest = {
            tipoRetirada: tipoRetirada,
            formaPagamento: fp,
        };

        requestService(
            fecharTotem.url.replaceAll("{id}", pedidoPk.replaceAll(/#/g, '%23')),
            {
                method: fecharTotem.method,
                headers: [["token", window.localStorage.getItem("token")]],
                body: JSON.stringify(objRequest),
                credentials: 'include'
            },
            history,
            async (response: any) => {
                const attrs = response?.dadosPedido?.Attributes || {};

                // Atualiza estado com dados frescos do backend
                if (attrs.valorTotal) setValorTotal(attrs.valorTotal);
                if (attrs.valorTotalProdutos) setValorTotal(attrs.valorTotalProdutos);
                if (attrs.produtos) setProdutos(attrs.produtos);
                if (attrs.tipoRetirada) setTipoRetirada(attrs.tipoRetirada);
                if (attrs.formaPagamento) setFormaPagamento(Array.isArray(attrs.formaPagamento) ? attrs.formaPagamento : fp);
                if (attrs.nomeProjeto) setNumeroPedido(String(attrs.nomeProjeto));

                // Impressão automática com dados frescos do backend
                if (dadosEmpresa?.impressaoAutomatica) {
                    try {
                        const dadosPedido = {
                            ...attrs,
                            dataCupom: attrs.dataAlteracao || new Date().toISOString(),
                            nomeProjeto: attrs.nomeProjeto || numeroPedido,
                            interno: true,
                        };

                        imprimirCupomCozinha(dadosPedido, dadosEmpresa);
                        imprimirCupom(dadosPedido, dadosEmpresa);

                    } catch (e) {
                        console.error('Erro ao imprimir cupom do totem:', e);
                    }
                }
                if (callback) callback();
            },
            (error: any) => {
                setTextToast(error?.message || "Erro ao fechar pedido.");
                setShowToast(true);
            }
        ).finally(() => setShowLoading(false));
    }

    // === Navigation ===
    function goNext() {
        const idx = TOTEM_STEPS.indexOf(step);
        if (idx < TOTEM_STEPS.length - 1) {
            setStep(TOTEM_STEPS[idx + 1]);
        }
    }

    function goBack() {
        const idx = TOTEM_STEPS.indexOf(step);
        if (idx > 0) {
            setStep(TOTEM_STEPS[idx - 1]);
        }
    }

    function goTo(s: TotemStep) {
        setStep(s);
    }

    function handleInicioStart() {
        setStep('identificacao');
    }

    function handleIdentificacaoNext(nome: string) {
        abrirPedido(nome);
    }

    function handleIdentificacaoPular() {
        abrirPedido("Cliente");
    }

    function handleCardapioNext() {
        salvarProdutos(produtos, tipoRetirada, () => {
            setStep('revisao');
        });
    }

    function handleRetiradaNext() {
        setStep('cardapio');
    }

    function handleRevisaoNext() {
        setStep('pagamento');
    }

    function handlePagamentoConfirmado(formaPagamentoParam: any) {
        const fp = Array.isArray(formaPagamentoParam) ? formaPagamentoParam : [formaPagamentoParam];
        setFormaPagamento(fp);
        fecharPedido(fp, () => {
            setStep('confirmacao');
        });
    }

    function handleConfirmacaoFinalizar() {
        // setMostrarHeader(false);
        resetTotem();
    }

    function renderStep() {
        switch (step) {
            case 'inicio':
                return <TelaInicial onStart={handleInicioStart} dadosEmpresa={dadosEmpresa} />;
            case 'identificacao':
                return <TelaIdentificacao onNext={handleIdentificacaoNext} onPular={handleIdentificacaoPular} onBack={() => goTo('inicio')} />;
            case 'cardapio':
                return (
                    <TelaCardapio
                        dadosEmpresa={dadosEmpresa}
                        produtos={produtos}
                        setProdutos={setProdutos}
                        clienteNome={clienteNome}
                        onNext={handleCardapioNext}
                        onBack={goBack}
                    />
                );
            case 'retirada':
                return <TelaRetirada tipoRetirada={tipoRetirada} setTipoRetirada={setTipoRetirada} onNext={handleRetiradaNext} onBack={goBack} />;
            case 'revisao':
                return (
                    <TelaRevisao
                        produtos={produtos}
                        valorTotal={valorTotal}
                        tipoRetirada={tipoRetirada}
                        onNext={handleRevisaoNext}
                        onBack={goBack}
                        onEditarCardapio={() => goTo('cardapio')}
                    />
                );
            case 'pagamento':
                return (
                    <TelaPagamento
                        valorTotal={valorTotal}
                        pedidoPk={pedidoPk}
                        dadosEmpresa={dadosEmpresa}
                        onConfirmar={handlePagamentoConfirmado}
                        onBack={goBack}
                    />
                );
            case 'confirmacao':
                return (
                    <TelaConfirmacao
                        pedidoPk={pedidoPk}
                        numeroPedido={numeroPedido}
                        dadosEmpresa={dadosEmpresa}
                        produtos={produtos}
                        valorTotal={valorTotal}
                        tipoRetirada={tipoRetirada}
                        formaPagamento={formaPagamento}
                        clienteNome={clienteNome}
                        onFinalizar={handleConfirmacaoFinalizar}
                    />
                );
            default:
                return <TelaInicial onStart={handleInicioStart} dadosEmpresa={dadosEmpresa} />;
        }
    }

    const stepIndex = TOTEM_STEPS.indexOf(step);

    function confirmarSelecaoTotem() {
        if (!totemSelecionadoTemp) {
            setTextToast("Selecione um totem.");
            setShowToast(true);
            return;
        }
        const totem = listaTotens.find((t: any) => t.pk === totemSelecionadoTemp);
        window.localStorage.setItem("totemSelecionado", totemSelecionadoTemp);
        window.localStorage.setItem("totemSelecionadoNome", totem?.nome || "Totem");
        setClienteTotemPk(totemSelecionadoTemp);
        setShowModalSelecionarTotem(false);
    }

    return (
        <IonPage onMouseDown={handlePressStart}
            onMouseUp={handlePressEnd}
            onTouchStart={handlePressStart}
            onTouchEnd={handlePressEnd}
            className="totem-page">
            {mostrarHeader && (
                <IonHeader className="ion-no-border" hidden={step !== 'inicio'} style={{ padding: '12px' }}>
                    <IonToolbar>
                        <IonButtons slot="end">
                            <IonButton onClick={openPopover}>
                                <IonIcon slot="icon-only" icon={ellipsisVertical} />
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
            )}

            <IonPopover
                isOpen={showPopover}
                event={popoverEvent}
                onDidDismiss={closePopover}
            >
                <IonList>
                    <IonItem lines="none" button onClick={() => {
                        history.push("/empresa/totemhistorico");
                        closePopover();
                    }}>
                        <IonIcon icon={folderOutline} slot="start" />
                        <IonLabel>Histórico</IonLabel>
                    </IonItem>
                    <IonItem lines="none" button onClick={() => {
                        history.push("/empresa/totemconfiguracoes");
                        closePopover();
                    }}>
                        <IonIcon icon={settingsOutline} slot="start" />
                        <IonLabel>Configurações</IonLabel>
                    </IonItem>
                    <IonItem lines="none" button onClick={() => {
                        closePopover();
                        setEsconderMenu(false);
                        history.replace("/empresa/inicio");
                    }}>
                        <IonIcon icon={logOutOutline} slot="start" />
                        <IonLabel>Sair do Totem</IonLabel>
                    </IonItem>

                    <IonItem lines="none" button onClick={closePopover}>
                        <IonIcon icon={closeOutline} slot="start" />
                        <IonLabel>Cancelar</IonLabel>
                    </IonItem>
                </IonList>
            </IonPopover>

            <IonContent scrollY={false}>
                {step !== 'inicio' && (
                    <ProgressBar current={stepIndex} total={TOTEM_STEPS.length} />
                )}

                <div className="totem-content">
                    {renderStep()}
                </div>

                {showInactivity && (
                    <InactivityOverlay
                        onContinue={handleContinueActivity}
                        onReset={handleInactivityReset}
                    />
                )}

                {/* === DEBUG — remover em produção === */}
                {/* <div style={{
                    position: 'fixed', bottom: 12, right: 12, zIndex: 9999,
                    background: 'rgba(0,0,0,0.82)', color: '#0f0', fontFamily: 'monospace',
                    fontSize: 13, padding: '10px 14px', borderRadius: 8, lineHeight: 1.7,
                    pointerEvents: 'none', minWidth: 220,
                }}>
                    <div>🐛 <strong>DEBUG TOTEM</strong></div>
                    <div>step: <strong>{step}</strong></div>
                    <div>timer: <strong style={{ color: debugSeconds < 20 ? '#f55' : '#0f0' }}>{debugSeconds}s</strong></div>
                    <div>status: {debugStatus}</div>
                    <div>overlay: <strong>{showInactivity ? '🔴 visível' : '⚫ oculto'}</strong></div>
                    <div>clienteTotemPk: {clienteTotemPk ? '✅' : '⏳'}</div>
                    <div>pedidoPk: {pedidoPk ? '✅' : '—'}</div>
                </div> */}
                {/* === FIM DEBUG === */}
            </IonContent>

            <IonLoading isOpen={showLoading} spinner="circles" />
            <IonToast
                isOpen={showToast}
                position="middle"
                onDidDismiss={() => setShowToast(false)}
                message={textToast}
                duration={3000}
            />

            {/* Modal seleção de totem */}
            <IonModal isOpen={showModalSelecionarTotem} backdropDismiss={false}>
                <IonHeader className="ion-no-border">
                    <IonToolbar>
                        <IonTitle>Selecione o Totem</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <IonList>
                        <IonItem>
                            <IonLabel position="stacked">Totem</IonLabel>
                            <IonSelect
                                interface="popover"
                                placeholder="Selecione o totem"
                                value={totemSelecionadoTemp}
                                onIonChange={(e) => setTotemSelecionadoTemp(e.detail.value)}
                            >
                                {listaTotens.map((totem: any) => (
                                    <IonSelectOption key={totem.pk} value={totem.pk}>
                                        {totem.nome || totem.pk}
                                    </IonSelectOption>
                                ))}
                            </IonSelect>
                        </IonItem>
                    </IonList>

                </IonContent>
                <IonFooter className="ion-no-border" >
                    <IonToolbar>
                        <IonButton expand="block" size='large' color="danger" onClick={confirmarSelecaoTotem}>
                            Confirmar
                        </IonButton>
                    </IonToolbar>
                </IonFooter>
            </IonModal>
        </IonPage>
    );
};

const Totem: React.FC = () => {
    return (
        <TotemProvider>
            <TotemInner />
        </TotemProvider>
    );
};

export default Totem;
